
import {
  Container,
    Image,
  Segment,
  Dropdown,
  Header,
  Table,
  Button,
} from 'semantic-ui-react'

import { useState } from 'react';

import { Link } from "react-router-dom";

import { ResponsiveContainer } from '../ResponsiveContainer';

import { useMutation, useQuery, gql } from '@apollo/client';

import { GET_TAGS as GET_POSSIBLE_TAGS } from '../../queries/tags';

const RESET_ATTENDANCE_ALERT = gql`
    mutation Mutation($alertId: Int) {
  resetAlert(alertId: $alertId) {
    id
  }
}`

const KICK_FROM_CLASS = gql`
    mutation KickStudentFromClass($courseId: Int, $userId: Int) {
  kickStudentFromClass(courseId: $courseId, userId: $userId) {
    status
  }
}`

const GET_ATTENDANCE_ALERTS = gql`
query AttendanceAlerts($filters: String) {
  attendanceAlerts(filters: $filters) {
    id
    course {
        id
        name
        SKU
        overseers {
            id
            name
            photoUrl
        }
    }
    last10Classes
    absentCount
    user {
        id
        identifier
        name
    }
    assignedUserId
    createdAt
    resetTime
    shouldShow
    updatedAt
  }
}`

const Attendance = () => {
    const [tagIds, setTagIds] = useState<string[]>([]);
    const { loading, error, data, refetch } = useQuery(GET_ATTENDANCE_ALERTS, { variables: { filters: "" } });
    const { loading: tagsLoading, error: tagsError, data: tagsData} = useQuery(GET_POSSIBLE_TAGS, {
        variables: {
            showPeopleTags: false,
            showCourseTags: true,
        }
    });

    const [resetAlert] = useMutation(RESET_ATTENDANCE_ALERT);
    const [kickFromClass] = useMutation(KICK_FROM_CLASS);

    if (loading) return <p>Loading...</p>;

    if (error) {
        console.error(error);
        return <p>Error loading attendance alerts.</p>;
    }
    if (!data || !data.attendanceAlerts) {
        return <p>No attendance alerts found.</p>;
    }

     const teacherItem = (overseer:any) => {
        return (
            <>
                <Image avatar src={overseer.photoUrl} size='tiny' style={{ width: '2em', height: '2em', objectFit: 'cover' }}/>
                <Link to={`/people/${overseer.id}`}>
                    {overseer.name}
                </Link>
                <br />
            </>
        )
     }


  return (
    <ResponsiveContainer>
      <Segment style={{ padding: '2em 0em' }} vertical>
        <Container>
            <Header as='h1' textAlign='center'>Attendance Dashboard</Header>
            <Dropdown
              placeholder='Tags'
              fluid
              multiple
              value={tagIds}
              onChange={(_, { value }) => {
                setTagIds(value as string[])
                refetch({ filters: value && (value as string[]).length > 0 ? (value as string[]).join(',') : ""})
              }}
              search
              selection
              options={
                tagsLoading || tagsError ? [] :
                (tagsData && tagsData.tags || [])
                  .map((p: any) => ({
                    key: p.id,
                    text: p.name,
                    value: `tagId:${p.id}`,
                  }))
              }
            />
            {/* Table of the alerts */}
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Class</Table.HeaderCell>
                        <Table.HeaderCell>Teacher</Table.HeaderCell>
                        <Table.HeaderCell>Person</Table.HeaderCell>
                        <Table.HeaderCell>Absent Count</Table.HeaderCell>
                        <Table.HeaderCell>Recent history</Table.HeaderCell>
                        <Table.HeaderCell>Action</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {data.attendanceAlerts.map((alert: any) => (
                        <Table.Row key={alert.id}>
                            <Table.Cell><Link to={`/courses/${alert.course.id}`}>{alert.course.name}</Link></Table.Cell>
                            <Table.Cell>{alert.course.overseers.map(teacherItem) || '-'}</Table.Cell>
                            <Table.Cell><Link to={`/people/${alert.user.id}`}>{alert.user.name} ({alert.user.identifier})</Link></Table.Cell>
                            <Table.Cell>{alert.absentCount}</Table.Cell>
                        <Table.Cell>{alert.last10Classes.split('').map((c: any, index: number) => (
                            <span key={index} style={{ marginRight: '0.5em' }}>
                                {c === '0' ? '❌' : c === '1' ? '✅' : c === '2' ? '❓' : ''}
                            </span>
                        ))}</Table.Cell>
                            <Table.Cell>
                                <Button
                                    color='red'
                                    onClick={async () => {
                                        // Kick the user from the class
                                        await kickFromClass({
                                            variables: {
                                                userId: alert.user.id,
                                                courseId: alert.course.id
                                            }
                                        }).then(() => {
                                                refetch({ filters: tagIds && tagIds.length > 0 ? tagIds.join(',') : "" }); // Refetch the alerts after kicking
                                        }).catch((err) => {
                                            console.error('Error kicking student:', err);
                                        });
                                    }}
                                >
                                    Remove from class
                                </Button>
                                <Button
                                    color='green'
                                    onClick={async () => {
                                        // Reset the alert
                                        await resetAlert({ variables: { alertId: alert.id } })
                                            .then(() => {
                                                refetch({ filters: tagIds && tagIds.length > 0 ? tagIds.join(',') : "" }); // Refetch the alerts after resetting
                                            })
                                            .catch((err) => {
                                                console.error('Error resetting alert:', err);
                                            });
                                    }}
                                >
                                    Reset alert
                                </Button>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

        </Container>
      </Segment>
    </ResponsiveContainer>
  )
}

export { Attendance }
